function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.69 0H0.0566406V3.96667H1.39014V27.317C1.39014 29.876 3.48115 31.967 6.04014 31.967H20.7068C23.2658 31.967 25.3568 29.876 25.3568 27.317V3.96667H26.69V0ZM24.0568 3.96667H2.69014V27.317C2.69014 29.158 4.19912 30.667 6.04014 30.667H10.0566V25.333H16.69V30.667H20.7068C22.5478 30.667 24.0568 29.158 24.0568 27.317V3.96667ZM1.35664 2.66667V1.3H25.39V2.66667H1.35664ZM15.39 30.667H11.3566V26.633H15.39V30.667ZM11.3901 6.66699H15.3568V13.3003H11.3901V6.66699ZM12.6901 7.96699V12.0003H14.0568V7.96699H12.6901ZM15.3568 16H11.3901V22.6333H15.3568V16ZM12.6901 21.3333V17.3H14.0568V21.3333H12.6901ZM5.39014 6.66699H9.3568V13.3003H5.39014V6.66699ZM6.69014 7.96699V12.0003H8.0568V7.96699H6.69014ZM21.3568 6.66699H17.3901V13.3003H21.3568V6.66699ZM18.6901 12.0003V7.96699H20.0568V12.0003H18.6901ZM5.39014 16H9.3568V22.6333H5.39014V16ZM6.69014 17.3V21.3333H8.0568V17.3H6.69014ZM21.3568 16H17.3901V22.6333H21.3568V16ZM18.6901 21.3333V17.3H20.0568V21.3333H18.6901Z",
  fill: "#2F7067"
});

var SvgBuilding = function SvgBuilding(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 32,
    viewBox: "0 0 27 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/building.a9b74da3.svg";
export { ForwardRef as ReactComponent };